// 詞牌名稱對照表 - 根據 ciPai.json 自動生成
// 總共 822 個詞牌

const CIPAI_NAMES = {
    "1": "一七令",
    "2": "一丛花",
    "3": "一剪梅",
    "4": "一叶落",
    "5": "一寸金",
    "6": "一斛珠",
    "7": "一枝春",
    "8": "一萼红",
    "9": "一落索",
    "10": "丁香结",
    "11": "七孃子",
    "12": "万年欢",
    "13": "万里春",
    "14": "三台",
    "15": "三台大曲",
    "16": "三奠子",
    "17": "三姝媚",
    "18": "三字令",
    "19": "三登乐",
    "20": "三部乐",
    "21": "上林春令",
    "22": "上林春慢",
    "23": "上行杯",
    "24": "下水船",
    "25": "且坐令",
    "26": "东坡引",
    "27": "东风第一枝",
    "28": "东风齐著力",
    "29": "两同心",
    "30": "中兴乐",
    "31": "临江仙",
    "32": "临江仙引",
    "33": "临江仙慢",
    "34": "丹凤吟",
    "35": "乌夜啼",
    "36": "乾荷叶",
    "37": "二色宫桃",
    "38": "二色莲",
    "39": "二郎神",
    "40": "于飞乐",
    "41": "云仙引",
    "42": "五福降中天",
    "43": "五綵结同心",
    "44": "人月圆",
    "45": "伊州三台",
    "46": "伊州令",
    "47": "传言玉女",
    "48": "伤春怨",
    "49": "佳人醉",
    "50": "使牛子",
    "51": "侍香金童",
    "52": "侧犯",
    "53": "促拍满路花",
    "54": "促拍采桑子",
    "55": "保寿乐",
    "56": "倒垂柳",
    "57": "倒犯",
    "58": "倚西楼",
    "59": "倚阑人",
    "60": "倦寻芳",
    "61": "倾杯乐",
    "62": "倾杯令",
    "63": "倾杯近",
    "64": "偷声木兰花",
    "65": "催雪",
    "66": "兀令",
    "67": "入塞",
    "68": "八六子",
    "69": "八声甘州",
    "70": "八宝妆",
    "71": "八归",
    "72": "八拍蛮",
    "73": "八节长欢",
    "74": "八音谐",
    "75": "六丑",
    "76": "六州",
    "77": "六州歌头",
    "78": "六幺令",
    "79": "六花飞",
    "80": "兰陵王",
    "81": "内家娇",
    "82": "冉冉云",
    "83": "凄凉犯",
    "84": "减字木兰花",
    "85": "凤凰台上忆吹箫",
    "86": "凤凰阁",
    "87": "凤孤飞",
    "88": "凤归云",
    "89": "凤来朝",
    "90": "凤楼春",
    "91": "凤池吟",
    "92": "凤衔杯",
    "93": "凤鸾双舞",
    "94": "凭阑人",
    "95": "击梧桐",
    "96": "别怨",
    "97": "剑器近",
    "98": "剔银灯",
    "99": "剔银镫",
    "100": "剪牡丹",
    "101": "劝金船",
    "102": "十二时慢",
    "103": "十六字令",
    "104": "十月桃",
    "105": "十样花",
    "106": "千年调",
    "107": "千秋岁",
    "108": "千秋岁引",
    "109": "升平乐",
    "110": "华清引",
    "111": "华胥引",
    "112": "卓牌子",
    "113": "卓牌子近",
    "114": "南乡一剪梅",
    "115": "南乡子",
    "116": "南州春色",
    "117": "南歌子",
    "118": "南浦",
    "119": "卜算子",
    "120": "卜算子慢",
    "121": "占春芳",
    "122": "厅前柳",
    "123": "厌金杯",
    "124": "双双燕",
    "125": "双声子",
    "126": "双头莲",
    "127": "双头莲令",
    "128": "双瑞莲",
    "129": "双雁儿",
    "130": "双韵子",
    "131": "双鸂鶒",
    "132": "受恩深",
    "133": "古香慢",
    "134": "合欢带",
    "135": "吊严陵",
    "136": "后庭宴",
    "137": "后庭花",
    "138": "后庭花破子",
    "139": "向湖边",
    "140": "品令",
    "141": "哨遍",
    "142": "唐多令",
    "143": "啰唝曲",
    "144": "喜团圆",
    "145": "喜春来",
    "146": "喜朝天",
    "147": "喜迁莺",
    "148": "喜长新",
    "149": "喝火令",
    "150": "四园竹",
    "151": "四槛花",
    "152": "四犯令",
    "153": "四犯剪梅花",
    "154": "回波乐",
    "155": "国香",
    "156": "垂丝钓",
    "157": "垂杨",
    "158": "城头月",
    "159": "塞垣春",
    "160": "塞姑",
    "161": "塞孤",
    "162": "塞翁吟",
    "163": "声声慢",
    "164": "夏云峰",
    "165": "夏日燕黉堂",
    "166": "多丽",
    "167": "夜半乐",
    "168": "夜合花",
    "169": "夜游宫",
    "170": "夜行船",
    "171": "夜飞鹊慢",
    "172": "大圣乐",
    "173": "大有",
    "174": "大椿",
    "175": "大酺",
    "176": "天下乐",
    "177": "天仙子",
    "178": "天净沙",
    "179": "天门谣",
    "180": "天香",
    "181": "太常引",
    "182": "太平年",
    "183": "夺锦标",
    "184": "女冠子",
    "185": "好事近",
    "186": "好女儿",
    "187": "好时光",
    "188": "如梦令",
    "189": "如鱼水",
    "190": "婆罗门令",
    "191": "婆罗门引",
    "192": "子夜歌",
    "193": "字字双",
    "194": "孤馆深沉",
    "195": "孤鸾",
    "196": "安公子",
    "197": "安平乐慢",
    "198": "定西番",
    "199": "定风波",
    "200": "定风波慢",
    "201": "宜男草",
    "202": "宝鼎现",
    "203": "宣清",
    "204": "宴清都",
    "205": "宴琼林",
    "206": "家山好",
    "207": "寰海清",
    "208": "寻梅",
    "209": "寻芳草",
    "210": "导引",
    "211": "寿山曲",
    "212": "寿延长破字令",
    "213": "寿楼春",
    "214": "寿阳曲",
    "215": "尉迟杯",
    "216": "小圣乐",
    "217": "小重山",
    "218": "小镇西犯",
    "219": "少年心",
    "220": "少年游",
    "221": "少年游慢",
    "222": "尾犯",
    "223": "山亭宴",
    "224": "山亭柳",
    "225": "山花子",
    "226": "巫山一段云",
    "227": "市桥柳",
    "228": "师师令",
    "229": "帝台春",
    "230": "平湖乐",
    "231": "并蒂芙蓉",
    "232": "庆千秋",
    "233": "庆宣和",
    "234": "庆春宫",
    "235": "庆春时",
    "236": "庆春泽",
    "237": "庆清朝",
    "238": "庆金枝",
    "239": "应天长",
    "240": "应景乐",
    "241": "引驾行",
    "242": "归去来",
    "243": "归国谣",
    "244": "归字谣",
    "245": "归朝欢",
    "246": "归田乐",
    "247": "归自谣",
    "248": "彩云归",
    "249": "彩凤飞",
    "250": "彩鸾归令",
    "251": "征招",
    "252": "征招调中腔",
    "253": "征部乐",
    "254": "御带花",
    "255": "御街行",
    "256": "忆东坡",
    "257": "忆余杭",
    "258": "忆少年",
    "259": "忆帝京",
    "260": "忆旧游",
    "261": "忆汉月",
    "262": "忆江南",
    "263": "忆王孙",
    "264": "忆瑶姬",
    "265": "忆秦娥",
    "266": "忆闷令",
    "267": "忆黄梅",
    "268": "快活年近拍",
    "269": "念奴娇",
    "270": "思帝乡",
    "271": "思归乐",
    "272": "思越人",
    "273": "思远人",
    "274": "怨三三",
    "275": "怨回纥",
    "276": "恋情深",
    "277": "恋绣衾",
    "278": "恋芳春慢",
    "279": "恋香衾",
    "280": "恨春迟",
    "281": "恨来迟",
    "282": "情久长",
    "283": "惜余欢",
    "284": "惜分飞",
    "285": "惜奴娇",
    "286": "惜寒梅",
    "287": "惜春令",
    "288": "惜春郎",
    "289": "惜琼花",
    "290": "惜秋华",
    "291": "惜红衣",
    "292": "惜花春起早慢",
    "293": "惜黄花",
    "294": "惜黄花慢",
    "295": "意难忘",
    "296": "感恩多",
    "297": "感皇恩",
    "298": "慢卷绸",
    "299": "戚氏",
    "300": "扑蝴蝶",
    "301": "扫地游",
    "302": "扫地舞",
    "303": "扬州慢",
    "304": "折丹桂",
    "305": "折桂令",
    "306": "折红梅",
    "307": "折花令",
    "308": "抛毬乐",
    "309": "拂霓裳",
    "310": "拜新月",
    "311": "拜星月慢",
    "312": "拨棹子",
    "313": "拾翠羽",
    "314": "换巢鸾凤",
    "315": "捣练子",
    "316": "探春令",
    "317": "探春慢",
    "318": "探芳信",
    "319": "接贤宾",
    "320": "握金钗",
    "321": "摊破南乡子",
    "322": "摊破采桑子",
    "323": "摘得新",
    "324": "摸鱼儿",
    "325": "撼庭秋",
    "326": "撼庭竹",
    "327": "散余霞",
    "328": "散天花",
    "329": "斗百草",
    "330": "新荷叶",
    "331": "新雁过妆楼",
    "332": "无愁可解",
    "333": "无闷",
    "334": "早梅芳",
    "335": "早梅芳慢",
    "336": "早梅香",
    "337": "明月逐人来",
    "338": "映山红慢",
    "339": "春云怨",
    "340": "春从天上来",
    "341": "春光好",
    "342": "春声碎",
    "343": "春夏两相期",
    "344": "春晓曲",
    "345": "春草碧",
    "346": "春雪间早梅",
    "347": "春风袅娜",
    "348": "昭君怨",
    "349": "昼夜乐",
    "350": "昼锦堂",
    "351": "晴偏好",
    "352": "暗香",
    "353": "暗香疏影",
    "354": "曲江秋",
    "355": "曲游春",
    "356": "曲玉管",
    "357": "更漏子",
    "358": "最高楼",
    "359": "月上海棠",
    "360": "月下笛",
    "361": "月中桂",
    "362": "月华清",
    "363": "月宫春",
    "364": "月当厅",
    "365": "月边娇",
    "366": "有有令",
    "367": "望云涯引",
    "368": "望云间",
    "369": "望仙门",
    "370": "望南云慢",
    "371": "望明河",
    "372": "望春回",
    "373": "望梅花",
    "374": "望江东",
    "375": "望江怨",
    "376": "望海潮",
    "377": "望湘人",
    "378": "望远行",
    "379": "朝中措",
    "380": "朝天子",
    "381": "朝玉阶",
    "382": "期夜月",
    "383": "木兰花令",
    "384": "木兰花慢",
    "385": "木笪",
    "386": "杏园芳",
    "387": "杏花天",
    "388": "杏花天慢",
    "389": "杜韦娘",
    "390": "杨柳枝",
    "391": "松梢月",
    "392": "极相思",
    "393": "枕屏儿",
    "394": "柘枝引",
    "395": "柳初新",
    "396": "柳含烟",
    "397": "柳摇金",
    "398": "柳梢青",
    "399": "柳腰轻",
    "400": "桂枝香",
    "401": "桂殿秋",
    "402": "桃源忆故人",
    "403": "梁州令",
    "404": "梅子黄时雨",
    "405": "梅弄影",
    "406": "梅花引",
    "407": "梅香慢",
    "408": "梦仙郎",
    "409": "梦扬州",
    "410": "梦横塘",
    "411": "梦玉人引",
    "412": "梦芙蓉",
    "413": "梦行云",
    "414": "梦还京",
    "415": "梧叶儿",
    "416": "梧桐影",
    "417": "楚宫春慢",
    "418": "楼上曲",
    "419": "檐前铁",
    "420": "欸乃曲",
    "421": "歌头",
    "422": "步月",
    "423": "步虚子令",
    "424": "步蟾宫",
    "425": "武陵春",
    "426": "殢人娇",
    "427": "殿前欢",
    "428": "氐州第一",
    "429": "水仙子",
    "430": "水晶帘",
    "431": "水调歌头",
    "432": "水龙吟",
    "433": "永遇乐",
    "434": "汉宫春",
    "435": "江亭怨",
    "436": "江南春慢",
    "437": "江城子",
    "438": "江城子慢",
    "439": "江城梅花引",
    "440": "江月晃重山",
    "441": "沁园春",
    "442": "沙塞子",
    "443": "河传",
    "444": "河渎神",
    "445": "河满子",
    "446": "法曲献仙音",
    "447": "法驾导引",
    "448": "泛兰舟",
    "449": "泛清波摘遍",
    "450": "泛青苕",
    "451": "洞仙歌",
    "452": "洞天春",
    "453": "浣溪沙",
    "454": "浣溪沙慢",
    "455": "浪淘沙",
    "456": "浪淘沙令",
    "457": "浪淘沙慢",
    "458": "海棠春",
    "459": "淡黄柳",
    "460": "添声杨柳枝",
    "461": "清商怨",
    "462": "清平乐",
    "463": "清江曲",
    "464": "清波引",
    "465": "清风八咏楼",
    "466": "清风满桂楼",
    "467": "渔家傲",
    "468": "渔歌子",
    "469": "渔父引",
    "470": "渡江云",
    "471": "湘春夜月",
    "472": "湘江静",
    "473": "满宫花",
    "474": "满庭芳",
    "475": "满朝欢",
    "476": "满江红",
    "477": "滴滴金",
    "478": "潇湘神",
    "479": "潇湘逢故人慢",
    "480": "澡兰香",
    "481": "点绛唇",
    "482": "烛影摇红",
    "483": "熙州慢",
    "484": "燕山亭",
    "485": "燕归梁",
    "486": "燕春台",
    "487": "爪茉莉",
    "488": "爱月夜眠迟慢",
    "489": "献天寿",
    "490": "献天寿令",
    "491": "献衷心",
    "492": "玉京秋",
    "493": "玉京谣",
    "494": "玉人歌",
    "495": "玉团儿",
    "496": "玉堂春",
    "497": "玉女摇仙佩",
    "498": "玉女迎春慢",
    "499": "玉山枕",
    "500": "玉抱肚",
    "501": "玉梅令",
    "502": "玉梅香慢",
    "503": "玉楼人",
    "504": "玉楼春",
    "505": "玉漏迟",
    "506": "玉烛新",
    "507": "玉簟凉",
    "508": "玉蝴蝶",
    "509": "玉连环",
    "510": "玉阑干",
    "511": "玲珑四犯",
    "512": "玲珑玉",
    "513": "珍珠令",
    "514": "珠帘卷",
    "515": "琐寒窗",
    "516": "琐窗寒",
    "517": "琵琶仙",
    "518": "瑞云浓",
    "519": "瑞云浓慢",
    "520": "瑞鹤仙",
    "521": "瑞鹧鸪",
    "522": "瑞龙吟",
    "523": "瑶华",
    "524": "瑶台月",
    "525": "瑶台第一层",
    "526": "瑶阶草",
    "527": "甘州令",
    "528": "甘州曲",
    "529": "甘州遍",
    "530": "甘草子",
    "531": "甘露歌",
    "532": "甘露滴乔松",
    "533": "生查子",
    "534": "画堂春",
    "535": "留客住",
    "536": "留春令",
    "537": "番枪子",
    "538": "疏影",
    "539": "白苎",
    "540": "白雪",
    "541": "百媚孃",
    "542": "百宜娇",
    "543": "皂罗特髻",
    "544": "盐角儿",
    "545": "相思儿令",
    "546": "相思引",
    "547": "相见欢",
    "548": "眉妩",
    "549": "看花回",
    "550": "真珠帘",
    "551": "真珠髻",
    "552": "眼儿媚",
    "553": "睿恩新",
    "554": "石州慢",
    "555": "石湖仙",
    "556": "破字令",
    "557": "破阵乐",
    "558": "破阵子",
    "559": "碧牡丹",
    "560": "祝英台近",
    "561": "祭天神",
    "562": "福寿千春",
    "563": "离亭宴",
    "564": "离别难",
    "565": "秋兰香",
    "566": "秋夜月",
    "567": "秋夜雨",
    "568": "秋宵吟",
    "569": "秋思耗",
    "570": "秋色横空",
    "571": "秋蕊香",
    "572": "秋蕊香引",
    "573": "秋霁",
    "574": "秋风清",
    "575": "穆护砂",
    "576": "章台柳",
    "577": "端正好",
    "578": "竹枝",
    "579": "竹香子",
    "580": "竹马儿",
    "581": "笛家",
    "582": "箇侬",
    "583": "簇水",
    "584": "粉蝶儿",
    "585": "粉蝶儿慢",
    "586": "系裙腰",
    "587": "索酒",
    "588": "紫玉箫",
    "589": "紫萸香慢",
    "590": "红林檎近",
    "591": "红窗听",
    "592": "红窗迥",
    "593": "红罗袄",
    "594": "红芍药",
    "595": "纥那曲",
    "596": "纱窗恨",
    "597": "绕池游",
    "598": "绛都春",
    "599": "绣停针",
    "600": "绮寮怨",
    "601": "绮罗香",
    "602": "绿盖舞风轻",
    "603": "缑山月",
    "604": "罥马索",
    "605": "翠楼吟",
    "606": "翠羽吟",
    "607": "翻香令",
    "608": "聒龙谣",
    "609": "胜州令",
    "610": "胜胜令",
    "611": "胡捣练",
    "612": "腊梅香",
    "613": "舜韶新",
    "614": "舞杨花",
    "615": "舞马词",
    "616": "芙蓉月",
    "617": "芭蕉雨",
    "618": "芰荷香",
    "619": "花上月令",
    "620": "花前饮",
    "621": "花发沁园春",
    "622": "花发状元红慢",
    "623": "花心动",
    "624": "花犯",
    "625": "花非花",
    "626": "芳草",
    "627": "芳草渡",
    "628": "苏幕遮",
    "629": "茅山逢故人",
    "630": "茶瓶儿",
    "631": "荔子丹",
    "632": "荔枝香",
    "633": "荷华媚",
    "634": "荷叶杯",
    "635": "荷叶铺水面",
    "636": "莺啼序",
    "637": "菊花新",
    "638": "菩萨蛮",
    "639": "菩萨蛮慢",
    "640": "落梅",
    "641": "落梅风",
    "642": "蓦山溪",
    "643": "蕃女怨",
    "644": "蕊珠閒",
    "645": "蕙兰芳引",
    "646": "薄倖",
    "647": "薄媚摘遍",
    "648": "虞美人",
    "649": "蜀溪春",
    "650": "蝴蝶儿",
    "651": "蝶恋花",
    "652": "行香子",
    "653": "行香子慢",
    "654": "被花恼",
    "655": "西吴曲",
    "656": "西地锦",
    "657": "西子妆",
    "658": "西平乐",
    "659": "西施",
    "660": "西江月",
    "661": "西江月慢",
    "662": "西河",
    "663": "西湖月",
    "664": "西溪子",
    "665": "角招",
    "666": "解佩令",
    "667": "解红",
    "668": "解红慢",
    "669": "解语花",
    "670": "解蹀躞",
    "671": "解连环",
    "672": "诉衷情",
    "673": "诉衷情令",
    "674": "诉衷情近",
    "675": "误桃源",
    "676": "调笑令",
    "677": "谒金门",
    "678": "谢池春",
    "679": "谢池春慢",
    "680": "贺圣朝",
    "681": "贺新郎",
    "682": "贺熙朝",
    "683": "赏南枝",
    "684": "赏松菊",
    "685": "赞成功",
    "686": "赞浦子",
    "687": "赤枣子",
    "688": "越江吟",
    "689": "越溪春",
    "690": "踏歌",
    "691": "踏歌词",
    "692": "踏莎行",
    "693": "踏青游",
    "694": "轮台子",
    "695": "辊绣毬",
    "696": "过涧歇",
    "697": "过秦楼",
    "698": "迎新春",
    "699": "迎春乐",
    "700": "还京乐",
    "701": "远朝归",
    "702": "连理枝",
    "703": "迷仙引",
    "704": "迷神引",
    "705": "送入我门来",
    "706": "送征衣",
    "707": "选冠子",
    "708": "逍遥乐",
    "709": "透碧霄",
    "710": "遍地锦",
    "711": "遐方怨",
    "712": "遥天奉翠华引",
    "713": "遶佛阁",
    "714": "遶池游慢",
    "715": "郭郎儿近拍",
    "716": "酒泉子",
    "717": "酷相思",
    "718": "醉乡春",
    "719": "醉公子",
    "720": "醉吟商",
    "721": "醉垂鞭",
    "722": "醉太平",
    "723": "醉妆词",
    "724": "醉思仙",
    "725": "醉春风",
    "726": "醉红妆",
    "727": "醉翁操",
    "728": "醉花间",
    "729": "醉花阴",
    "730": "醉蓬莱",
    "731": "醉高歌",
    "732": "采明珠",
    "733": "采桑子",
    "734": "采桑子慢",
    "735": "采绿吟",
    "736": "采莲令",
    "737": "采莲子",
    "738": "金人捧露盘",
    "739": "金凤鈎",
    "740": "金字经",
    "741": "金明池",
    "742": "金浮图",
    "743": "金盏倒垂莲",
    "744": "金盏子",
    "745": "金盏子令",
    "746": "金莲绕凤楼",
    "747": "金菊对芙蓉",
    "748": "金蕉叶",
    "749": "金错刀",
    "750": "钗头凤",
    "751": "钿带长中调",
    "752": "锁寒窗",
    "753": "锁窗寒",
    "754": "锦园春",
    "755": "锦堂春慢",
    "756": "锦帐春",
    "757": "锦缠道",
    "758": "锯解令",
    "759": "长亭怨慢",
    "760": "长命女",
    "761": "长寿乐",
    "762": "长寿仙",
    "763": "长生乐",
    "764": "长相思",
    "765": "长相思慢",
    "766": "閒中好",
    "767": "阮郎归",
    "768": "阳关引",
    "769": "阳关曲",
    "770": "阳台梦",
    "771": "阳台路",
    "772": "阳春",
    "773": "陌上花",
    "774": "隔帘听",
    "775": "隔浦莲近拍",
    "776": "雨中花令",
    "777": "雨中花慢",
    "778": "雨霖铃",
    "779": "雪夜渔舟",
    "780": "雪明鳷鹊夜",
    "781": "雪梅香",
    "782": "雪狮儿",
    "783": "雪花飞",
    "784": "霓裳中序第一",
    "785": "霜叶飞",
    "786": "霜天晓角",
    "787": "霜花腴",
    "788": "露华",
    "789": "青玉案",
    "790": "青门引",
    "791": "青门饮",
    "792": "鞓红",
    "793": "韵令",
    "794": "风光好",
    "795": "风入松",
    "796": "风流子",
    "797": "飞雪满群山",
    "798": "飞龙宴",
    "799": "饮马歌",
    "800": "马家春慢",
    "801": "驻马听",
    "802": "高山流水",
    "803": "高平探芳新",
    "804": "高阳台",
    "805": "鬓边华",
    "806": "鬭百花",
    "807": "鬲溪梅令",
    "808": "鱼游春水",
    "809": "鹊桥仙",
    "810": "鹤冲天",
    "811": "鹦鹉曲",
    "812": "鹧鸪天",
    "813": "麦秀两岐",
    "814": "黄河清慢",
    "815": "黄莺儿",
    "816": "黄钟乐",
    "817": "黄鹂绕碧树",
    "818": "黄鹤引",
    "819": "黄鹤洞仙",
    "820": "鼓笛令",
    "821": "齐天乐",
    "822": "龙山会"
};

// 根據詞牌 ID 獲取詞牌名稱
function getCipaiName(ci_pai_id) {
    const id = parseInt(ci_pai_id);
    return CIPAI_NAMES[id] || `詞牌 ${id}`;
}

// ES6 導出
export { getCipaiName, CIPAI_NAMES };

// 如果是在瀏覽器環境中，將函數添加到全局範圍
if (typeof window !== 'undefined') {
    window.getCipaiName = getCipaiName;
}

// 如果是在 Node.js 環境中，導出函數
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { getCipaiName, CIPAI_NAMES };
}
